import { createError } from "core/exceptions";
import { createSagasForBasicCall } from "core/sagas";
import log from "loglevel";
import { call, put, select, takeLatest } from "redux-saga/effects";
import FilmReleaseService from "services/filmReleaseService";
import { actions } from "./filmFormActions";
import {
    formatFilmReleaseToEdit,
    formatForNewFilm,
    getFilmReleaseFormCallback,
    getFormState,
    getNewFilmRelease,
} from "./sagaHelpers";

export function* loadFilmReleaseToEdit({ payload }) {
    log.debug("toggling form");
    try {
        const { filmReleaseTypeID, filmRelease } = payload;
        const { editing, open, id } = yield select(getFormState);
        log.debug(editing, open, id);
        if (editing && open && id) {
            const response = yield call(FilmReleaseService.getFilmRelease, id);

            log.debug("filmRelease ", response.data, formatFilmReleaseToEdit(response.data));
            yield put(actions.TOGGLE_FILM_RELEASE_FORM.success({ data: formatFilmReleaseToEdit(response.data) }));
        } else if (!id && editing) {
            log.error("No id has been assigned. Check loadFilmReleaseToEdit saga");
            yield put(actions.TOGGLE_FILM_RELEASE_FORM.failed());
        } else {
            if (filmRelease) {
                filmReleaseTypeID !== -1 ? filmReleaseTypeID : null;
                yield put(actions.TOGGLE_FILM_RELEASE_FORM.success({ data: formatForNewFilm(filmRelease) }));
            } else {
                yield put(actions.TOGGLE_FILM_RELEASE_FORM.success());
            }
        }
    } catch (e) {
        log.error(e);
        yield put(actions.TOGGLE_FILM_RELEASE_FORM.failed(null, createError(e)));
    }
}

export function* addFilmRelease() {
    log.debug("adding...");
    try {
        const newFR = yield select(getNewFilmRelease);
        const callback = yield select(getFilmReleaseFormCallback);
        yield call(FilmReleaseService.createFilmRelease, newFR);
        callback();
        yield put(actions.ADD_FILM_RELEASE.success());
    } catch (e) {
        log.debug(e);
        yield put(actions.ADD_FILM_RELEASE.failed(null, createError(e)));
    }
}
export function* editFilmRelease() {
    try {
        const newFR = yield select(getNewFilmRelease);

        const id = newFR.id;
        const callback = yield select(getFilmReleaseFormCallback);
        yield call(FilmReleaseService.editFilmRelease, { ...newFR, id });
        callback();
        yield put(actions.EDIT_FILM_RELEASE.success());
    } catch (e) {
        log.error(e);
        yield put(actions.EDIT_FILM_RELEASE.failed(null, createError(e)));
    }
}

export function* mergeFilmRelease({ payload }) {
    try {
        const { sourceFilmR, targetFilmR } = payload;
        yield call(FilmReleaseService.mergeFilmRelease, sourceFilmR.id, targetFilmR.id);
        const response = yield call(FilmReleaseService.getFilmRelease, targetFilmR.id);
        yield put(actions.MERGE_FILM_RELEASE.success({ data: formatFilmReleaseToEdit(response.data) }));
    } catch (e) {
        log.error(e);
        yield put(actions.MERGE_FILM_RELEASE.failed(null, createError(e)));
    }
}

export function* associateFilmRelease({ payload }) {
    try {
        const { sourceFilmR, targetFilmR } = payload;
        yield call(FilmReleaseService.associateFilmRelease, sourceFilmR.id, targetFilmR.id);
        const response = yield call(FilmReleaseService.getFilmRelease, targetFilmR.id);
        yield put(actions.ASSOCIATION_FILM_RELEASE.success({ data: formatFilmReleaseToEdit(response.data) }));
    } catch (e) {
        log.error(e);
        yield put(actions.ASSOCIATION_FILM_RELEASE.failed(null, createError(e)));
    }
}

export default [
    ...createSagasForBasicCall(actions),
    takeLatest(actions.TOGGLE_FILM_RELEASE_FORM.sendType, loadFilmReleaseToEdit),
    takeLatest(actions.ADD_FILM_RELEASE.sendType, addFilmRelease),
    takeLatest(actions.EDIT_FILM_RELEASE.sendType, editFilmRelease),
    takeLatest(actions.MERGE_FILM_RELEASE.sendType, mergeFilmRelease),
    takeLatest(actions.ASSOCIATION_FILM_RELEASE.sendType, associateFilmRelease),
];
